export default __webpack_public_path__ + "static/media/donacion_esterilizacion.09a59b8c.png";